import React, { Suspense, lazy, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.scss";

import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import { Loader } from "components";
import Dashboard from "views/Dashboard";
import ImageViewer from "components/TailedImage";

const ImagePipeline = lazy(() => import("./views/Report/ImagePipeline"));
const ImageFoolboxPipeline = lazy(() => import("./views/Report/ImageFoolbox"));
const Structured = lazy(() => import("./views/Report/Structured"));
const Regression = lazy(() => import("./views/Report/Regression"));
const TextPipeline = lazy(() => import("./views/Report/TextPipeline"));
const AudioPipeline = lazy(() => import("./views/Report/AudioPipeline"));
const TimeSeriesPipeline = lazy(
  () => import("./views/Report/TimeseriesPipeline"),
);
const ODPipeline = lazy(() => import("./views/Report/ODPipeline"));
const Segmentation = lazy(() => import("./views/Report/Segmentation"));
const Recommendation = lazy(() => import("./views/Report/Recommendation"));
const NewBias = lazy(() => import("./views/Report/NewBias"));

const NotFound = () => (
  <div style={{ textAlign: "center", padding: "50px" }}>
    <h1>404</h1>
    <p>Page not found</p>
  </div>
);

const App = () => {
  useEffect(() => {
    document.documentElement.style.setProperty("--text", "#fff");
    document.documentElement.style.setProperty("--bgColor", "#000");
    document.documentElement.style.setProperty("--content", "#a03c64");
  }, []);

  return (
    <Suspense fallback={<Loader />}>
      <Router>
        <Routes>
          <Route path="/structured/:id" element={<Structured />} />
          <Route path="/regression/:id" element={<Regression />} />
          <Route path="/image/:id" element={<ImagePipeline />} />
          <Route path="/imagefoolbox/:id" element={<ImageFoolboxPipeline />} />
          <Route path="/text/:id" element={<TextPipeline />} />
          <Route path="/audio/:id" element={<AudioPipeline />} />
          <Route path="/gpai/:id" element={<NewBias />} />
          <Route path="/" element={<Dashboard />} />
          <Route path="/timeseries/:id" element={<TimeSeriesPipeline />} />
          <Route path="/od/:id" element={<ODPipeline />} />
          <Route path="/viewer" element={<ImageViewer />} />
          <Route path="/segmentation/:id" element={<Segmentation />} />
          <Route path="/recommendation/:id" element={<Recommendation />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Router>
    </Suspense>
  );
};

export default App;
